/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Response for a single identity patch
 */
export interface IdentityPatchResponse { 
    /**
     * The action for this specific patch create ActionCreate  Create this identity. error ActionError  Error indicates that the patch failed.
     */
    action?: IdentityPatchResponse.ActionEnum;
    error?: any | null;
    /**
     * The identity ID payload of this patch
     */
    identity?: string;
    /**
     * The ID of this patch response, if an ID was specified in the patch.
     */
    patch_id?: string;
}
export namespace IdentityPatchResponse {
    export type ActionEnum = 'create' | 'error';
    export const ActionEnum = {
        Create: 'create' as ActionEnum,
        Error: 'error' as ActionEnum
    };
}


